import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-accordion-item',
  imports: [],
  templateUrl: './accordion-item.html',
  styleUrl: 'accordion-item.scss',
})
export class AccordionItem {
  id = input.required<string>();
  title = input.required<string>();
  currentsOpen = input<string[]>();
  

  onOpen = output<string>();
  onClose = output<string>();

  isOpen = computed(() => this.currentsOpen()!.includes(this.id()));

  handleToggle(): void {
    if (this.isOpen()) {
      this.onClose.emit(this.id());
    } else {
      this.onOpen.emit(this.id());
    }
  }
}
